import { TargetedUpsellTrackingEvents, UpsellName, UpsellStatus } from '../common';
import { getPageByPath } from '../components/upsell-feedback/UpsellFeedback';
import { AmplitudeTracking, EmbeddedQualtricsData, UpsellAnalytics } from '../hooks/useQualtricsAPI';

export interface HandleSurveyButtonClickArgs {
  response: boolean;
  user: any;
  upsellContent: string;
  market: string;
  userGroupIds?: string;
  userGroupNames?: string;
  country: string;
  clientName?: string;
  clientId?: number;
  urlTokenId: string;
  upsellType: UpsellName;
  dataPeriod?: string;
  upsellName: string;
  triggerQualtricsWorkflow: (params: {
    trackingText: string;
    triggerQualtrics: boolean;
    embeddedData: EmbeddedQualtricsData;
    analyticsData: UpsellAnalytics;
    trackingBody: AmplitudeTracking;
  }) => Promise<void>;
}

export const handleSurveyButtonClick = async (args: HandleSurveyButtonClickArgs): Promise<void> => {
  const {
    response,
    user,
    upsellContent,
    market,
    userGroupIds,
    userGroupNames,
    country,
    clientName,
    clientId,
    urlTokenId,
    upsellType,
    dataPeriod,
    upsellName,
    triggerQualtricsWorkflow,
  } = args;
  const embeddedData = {
    email: user?.email,
    userid: user?.userId,
    upsellContent,
    key: `${user?.userId}_${upsellType}_${market}${dataPeriod ? `_${dataPeriod}` : ''}`,
    market,
    country,
    userGroupIds,
    userGroupNames,
    clientName,
    clientId,
    urlTokenId,
  };

  const analyticsData = {
    cell: market,
    dataPeriod,
    upsellName,
    upsellStatus: response ? UpsellStatus.UPSELL_ACTIVATED : UpsellStatus.UPSELL_DECLINED,
  };
  await triggerQualtricsWorkflow({
    trackingText: response ? TargetedUpsellTrackingEvents.ACTIVATED : TargetedUpsellTrackingEvents.DECLINED,
    triggerQualtrics: response,
    embeddedData,
    analyticsData,
    trackingBody: {
      pageName: getPageByPath() ? getPageByPath().title : '',
      cell: market,
    },
  });
};
